import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-authority",
  "use": "icon-authority-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-authority\">\n<style type=\"text/css\">\n\t#icon-authority .st0{fill:#333333;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M24.8,5.4c-0.9-0.3-1.8-0.3-2.6,0L5,9.3v13.9c0,8.5,5.7,16,13.8,18.4l4.7,1.4l5.4-1.5C37.2,39.2,43,31.6,43,23\n\t\tV9.3L24.8,5.4z M40,23c0,7.3-4.9,13.7-11.9,15.6l-4.6,1.3l-3.9-1.1C12.8,36.8,8,30.4,8,23.3V11.7l14.9-3.4l0.2,0\n\t\tc0.3-0.1,0.6-0.1,0.9,0l16,3.5V23z\" />\n\t<path class=\"st0\" d=\"M17,18c0,3.3,2.4,6.1,5.5,6.8v8.7c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V33h2c0.8,0,1.5-0.7,1.5-1.5\n\t\tS28.3,30,27.5,30h-2v-1h2c0.8,0,1.5-0.7,1.5-1.5S28.3,26,27.5,26h-2v-1.2c3.1-0.7,5.5-3.5,5.5-6.8c0-3.9-3.1-7-7-7S17,14.1,17,18z\n\t\t M24,14c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S21.8,14,24,14z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcons/svg/authority.svg
// module id = zcBC
// module chunks = 35